import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";

interface Metric {
  title: string;
  description: string;
  value: string | number;
  unit?: string;
}
export const MonitoredParameters: React.FC<{ systemData: any }> = ({
  systemData,
}) => {
  const items = systemData?.monitoredParameters || [];

  if (!items.length) {
    return (
      <div className="text-center py-10 text-gray-500 text-sm">
        No monitored parameters available
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
      {items.map((item: any) => (
        <Card key={item.title} className="hover:shadow-md transition">
          <CardHeader>
            <CardTitle className="text-base font-semibold">
              {item.name}
            </CardTitle>
          </CardHeader>

          <CardContent>
            <p className="text-xs text-gray-500 leading-relaxed mb-4">
              {item.description}
            </p>

            <div className="text-3xl font-bold">
              {item.value}{" "}
              {item.unit && (
                <span className="text-sm font-medium text-gray-500">
                  {item.unit}
                </span>
              )}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
